// src/i18n/shared/messages.ts
import common_ceb_PH from "./jsons/ceb_PH.json";
import common_en_US from "./jsons/en_US.json";
import common_en_ZA from "./jsons/en_ZA.json";
import common_es_CO from "./jsons/es_CO.json";
import common_es_EC from "./jsons/es_EC.json";
import common_es_MX from "./jsons/es_MX.json";
import common_es_PA from "./jsons/es_PA.json";
import common_es_PE from "./jsons/es_PE.json";
import common_id_ID from "./jsons/id_ID.json";
import common_pt_BR from "./jsons/pt_BR.json";
import common_tl_PH from "./jsons/tl_PH.json";
// ... other shared translations

export default {
  ceb_PH: common_ceb_PH,
  en_US: common_en_US,
  en_ZA: common_en_ZA,
  es_CO: common_es_CO,
  es_EC: common_es_EC,
  es_MX: common_es_MX,
  es_PA: common_es_PA,
  es_PE: common_es_PE,
  id_ID: common_id_ID,
  pt_BR: common_pt_BR,
  tl_PH: common_tl_PH,
  // ... other locales
};
